import sanityClient from "@sanity/client";
import { sanityHostConfig } from "./lib/paths";

const clientSanity = sanityClient({
  projectId: "dl8tt1w0",
  dataset: "production",
  useCdn: true,
  ...sanityHostConfig,
});

export default clientSanity;